import {
    ApiBaseService,
    type ApiServiceConfig,
} from "~/services/ApiBaseService";
import type { ApiResponse } from "~/types/ApiResponse";

export interface ChatGPTModelsTemplate {
    id: string;
    created: number;
    object: string;
    ownedBy: string;
    [key: string]: string | number;
}

export default class ChatgptService extends ApiBaseService {
    protected uuid: string;

    constructor(uuid: string, config: ApiServiceConfig) {
        super(config);

        this.uuid = uuid;
    }

    public getModels(bustCache: boolean = false): Promise<ApiResponse<ChatGPTModelsTemplate[]>> {
        return this.request(
            this.route(
                "api.connections.chatgpt.models.index",
                "/connections/chatgpt/{connection}/models",
                {
                    connection: this.uuid,
                },
            ),
            {
                method: "GET",
                params: {
                    forget: bustCache,
                },
            },
        );
    }
}
